<template>
    <v-hover>
        <template v-slot="{ hover }">
            <v-card
                :elevation="hover ? 24 : 6"
                :style="{
                    border: '1px solid ' + servicio.color + ' !important'
                }"
                class="mx-auto"
                max-width="344"
                shaped
            >
                <v-card-title style="flex-wrap: nowrap;">
                    <v-flex 
                        :key="'sl_serv_icon_' + servicio.idServicio" 
                        xs12 
                        text-center>
                        <v-icon
                            :style="{
                                color: servicio.color + ' !important',
                                fontSize: '65px',
                                margin: '0 auto!important'
                            }"
                            x-large
                            cols="12"
                            xs="12"
                        >
                            {{ servicio.iconoMui }}
                        </v-icon>
                    </v-flex>
                    <v-flex 
                        :key="'sl_serv_txt_' + servicio.idServicio" 
                        xs12 
                        text-center>
                        <p
                            :style="{
                                color: servicio.color + ' !important',
                                margin: '0 auto!important',
                                fontSize: '1rem!important',
                                wordBreak: 'break-word',
                                lineHeight: '1rem!important',
                                fontWeight: '300!important'
                            }"
                            class="text-center"
                        >
                            {{ servicio.descripcion }}
                        </p>
                    </v-flex>
                </v-card-title>
                <v-card-text
                    v-if="
                        (idEstatus === 2 || idEstatus === 3 || idEstatus === 4) && !loading
                    "
                    :style="{
                        color: servicio.color + ' !important',
                        textAlign: 'center'
                    }"
                >
                    <div class="text--primary">Estatus</div>
                    <div>{{ estatus }}</div>
                </v-card-text>
                <v-card-actions>
                    <v-flex 
                        xs12 
                        text-center>
                        <v-skeleton-loader 
                            v-if="loading" 
                            type="text" />
                        <v-btn
                            v-else-if="idEstatus === 1 || idEstatus === 3"
                            :style="{
                                color: servicio.color + ' !important'
                            }"
                            text
                            @click="goSolicitudServicio()"
                        >Solicitar servicio</v-btn
                        >
                        <v-btn
                            v-else-if="idEstatus === 4"
                            :style="{
                                color: servicio.color + ' !important'
                            }"
                            text
                            @click="goSolicitudServicio()"
                        >Editar solicitud</v-btn
                        >
                        <div 
                            v-else 
                            class="text--primary" 
                            style="color: red">
                            {{ error }}
                        </div>
                    </v-flex>
                </v-card-actions>
                <!-- <v-card-text>
                    <v-row>
                      <v-col v-if="loading" class="py-1" cols="12">
                        <v-skeleton-loader type="text" />
                      </v-col>
                      <v-col v-else class="py-1" cols="12">
                        Servicios disponibles
                        <v-chip
                          class="mx-2"
                          small
                          color="primary"
                          style="float:right;"
                        >
                          {{ serviciosDisponibles }}
                        </v-chip>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col v-if="loading" class="py-1" cols="12">
                        <v-skeleton-loader type="text" />
                      </v-col>
                      <v-col v-else class="py-1" cols="12">
                        Solicitudes pendientes
                        <v-chip
                          class="mx-2"
                          small
                          color="primary"
                          style="float:right;"
                        >
                          {{ solicitudes }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-card-text> -->
            </v-card>
        </template>
    </v-hover>
</template>

<script>
import { getEstatusServicioDisponible } from "@/api";

export default {
  name: "IconoServicioDisponible",
  props: {
    servicio: {
      type: Object,
      required: true
    },
    goUrlSolicitud: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      idEstatus: 0,
      estatus: "",
      loading: true,
      error: ""
    };
  },
  mounted () {
    this.getEstatusServicioDisponible_();
  },
  methods: {
    async getEstatusServicioDisponible_ () {
      var self = this;
      self.loading = true;
      self.error = "";
      self.idEstatus = 0;
      self.estatus = "";

      try {
        let response = await getEstatusServicioDisponible(
          self.servicio.idServicio,
          self.servicio.claveServicio
        );

        if (response.status === 200) {
          if (response.data.flag === true) {
            self.loading = false;
            self.idEstatus = response.data.data.idEstatus;
            self.estatus = response.data.data.estatus;
          } else {
            self.loading = false;
            self.error = response.data.message;
          }
        } else {
          self.loading = false;
          self.error =
            "Servicio " + self.servicio.descripcion + ": Error de red";
        }
      } catch (e) {
        self.loading = false;
        self.error = "Servicio " + self.servicio.descripcion + ": " + e;
      }
    },
    goSolicitudServicio () {
      var self = this;
      if (
        self.idEstatus === 1 ||
        self.idEstatus === 3 ||
        self.idEstatus === 4
      ) {
        this.$router.push({
          path: `/Externo/SolicitudServicio/${self.servicio.idServicio}/${self.servicio.claveServicio}/${self.idEstatus}`
        }); // -> /user/123
      }
    },
    goUrlServicio (url, idServicio, claveServicio) {
      if (this.goUrlSolicitud) {
        this.$router.push({
          path: `/Externo/SolicitudServicio/${idServicio}/${claveServicio}`
        }); // -> /user/123
      } else {
        window.location.href = url;
      }
    }
  }
};
</script>
